/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IMandsSocialFooterData } from './mands-social-footer.data';
import { IMandsSocialFooterProps } from './mands-social-footer.props.autogenerated';

/**
 *
 * MandsSocialFooter component
 * @extends {React.PureComponent<IMandsSocialFooterProps<IMandsSocialFooterData>>}
 */
export default class MandsSocialFooter extends React.PureComponent<IMandsSocialFooterProps<IMandsSocialFooterData>> {
    public onImageClick = (destinationUrl: string) => {
        window.location.href = destinationUrl;
        return;
    };

    public render(): JSX.Element {
        const { config } = this.props;
        const socialItems = config.socialItems ? config.socialItems : [];

        return (
            <React.Fragment>
                <div className='sm-wrapper'>
                    <div className='container'>
                        <div className='row'>
                            {socialItems.map(socialItem => {
                                const imageSrc = socialItem && socialItem.image && socialItem.image && socialItem.image.src;
                                const imageHeight = socialItem && socialItem.image && socialItem.image && socialItem.image.height;
                                const imageWidth = socialItem && socialItem.image && socialItem.image && socialItem.image.width;
                                const destinationUrl =
                                    socialItem && socialItem.destinationUrl && socialItem.destinationUrl ? socialItem.destinationUrl : '';
                                const openInNewTab =
                                    socialItem && socialItem.openInNewTab && socialItem.openInNewTab ? socialItem.openInNewTab : undefined;
                                return (
                                    <div className='icon-container' key={socialItem.destinationUrl}>
                                        <a target={openInNewTab === true ? '_blank' : undefined} href={destinationUrl} rel='noreferrer'>
                                            <img height={imageHeight} width={imageWidth} alt='Background Image' src={imageSrc} />
                                        </a>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
